
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Taxiserviceinhinjewadipune() {



    const cardData =
    {
        keyword: 'Taxi Service in Hinjewadi, Pune  ',
        heading: 'Morya Cabs: Taxi Service in Hinjewadi, Pune  ',
        headingDescription: 'Morya Cabs offers dependable, affordable, and comfortable taxi services in Hinjewadi, Pune. Whether you are commuting to work, traveling to the airport, or exploring nearby attractions, our professional drivers and well-maintained vehicles ensure a smooth and safe journey. With on-time service, competitive pricing, and a focus on customer satisfaction, Morya Cabs is your go-to choice for all your transportation needs in Hinjewadi.',

        top: 'Top Places to Visit in Hinjewadi with Morya Cabs:',

"topPlaces": [
    {
        "title": "Rajiv Gandhi Infotech Park",
        "description": "Located in Hinjewadi, the Rajiv Gandhi Infotech Park is one of the largest IT hubs in Pune. It’s a bustling business center, housing several multinational companies and startups. A must-visit for business professionals."
    },
    {
        "title": "Balewadi High Street",
        "description": "Known for its trendy shops, restaurants, and cafes, Balewadi High Street is a vibrant spot for dining, shopping, and relaxation. It’s perfect for a day out or an evening stroll."
    },
    {
        "title": "Morya Gosavi Ganpati Temple",
        "description": "A popular spiritual spot, Morya Gosavi Ganpati Temple is known for its peaceful atmosphere and the annual Ganesh Chaturthi celebrations. It’s a serene place to visit for devotees and tourists alike."
    },
    {
        "title": "Pune International Exhibition Centre",
        "description": "This exhibition center hosts several trade shows, expos, and cultural events throughout the year. It’s an ideal location for those attending exhibitions or events in Hinjewadi."
    },
    {
        "title": "Sinhagad Fort",
        "description": "While not directly in Hinjewadi, Sinhagad Fort is a short drive away and is a popular tourist destination. Offering scenic views and historical significance, it’s perfect for hiking and nature walks."
    },
    {
        "title": "Shivaji Garden",
        "description": "A peaceful green space in Hinjewadi, Shivaji Garden is perfect for a quiet walk, picnic, or family outing. The garden offers a calm retreat from the busy city life."
    },
    {
        "title": "Xion Mall",
        "description": "Located in the nearby area, Xion Mall is a great spot for shopping, dining, and entertainment. With several stores, a food court, and a multiplex cinema, it’s a complete entertainment package."
    },
    {
        "title": "Rajat Jadhav Garden",
        "description": "A small but beautiful garden in the vicinity, Rajat Jadhav Garden is ideal for those seeking a relaxing environment amidst nature. It's perfect for families and nature lovers."
    }
],


"services": [
    {
      "name": "Hinjewadi Taxi Service",
      "description": "Morya Cab offers reliable and comfortable taxi services in Hinjewadi. Whether you're heading for work or a leisure trip, we provide quick, safe, and affordable rides."
    },
    {
      "name": "Taxi Booking Hinjewadi",
      "description": "Booking a taxi in Hinjewadi is easy with Morya Cab. Our simple and user-friendly booking options allow you to reserve your ride in minutes from your mobile or desktop."
    },
    {
      "name": "Taxi in Hinjewadi Pune",
      "description": "For a convenient taxi service in Hinjewadi, Pune, Morya Cab is your go-to choice. We provide fast and comfortable rides to suit all your travel needs."
    },
    {
      "name": "Cab Service Hinjewadi",
      "description": "Morya Cab offers a comprehensive range of cab services in Hinjewadi, providing hassle-free rides for both local and outstation travel. Your comfort and convenience are our priority."
    },
    {
      "name": "Hinjewadi Cab Booking",
      "description": "Book a reliable cab in Hinjewadi with Morya Cab. Our fast, affordable, and efficient services ensure that you get to your destination on time, every time."
    },
    {
      "name": "Reliable Taxi Hinjewadi",
      "description": "Looking for a reliable taxi in Hinjewadi? Morya Cab ensures timely pickups, professional drivers, and comfortable rides for all your transportation needs."
    },
    {
      "name": "Affordable Taxi Hinjewadi",
      "description": "Morya Cab provides affordable taxi services in Hinjewadi. With competitive pricing, we offer great value for money without compromising on comfort or safety."
    },
    {
      "name": "24/7 Taxi Service Hinjewadi",
      "description": "Morya Cab operates 24/7 taxi services in Hinjewadi. No matter the time of day or night, our cabs are always ready to take you wherever you need to go."
    },
    {
      "name": "Luxury Taxi Hinjewadi",
      "description": "For those seeking luxury rides, Morya Cab offers premium taxi services in Hinjewadi. Travel in style and comfort with our fleet of luxury vehicles."
    },
    {
      "name": "Hinjewadi Cab Service",
      "description": "Morya Cab offers efficient and convenient cab services in Hinjewadi. Our services are available for both local trips and outstation journeys, with a focus on punctuality and comfort."
    },
    {
      "name": "Taxi Service in Hinjewadi",
      "description": "Morya Cab offers dependable taxi services in Hinjewadi for all your travel needs. Whether it’s for a quick local ride or a long-distance trip, we have you covered."
    },
    {
      "name": "Hinjewadi Cab Service Pune",
      "description": "Morya Cab provides trusted and efficient cab services from Hinjewadi to various destinations in Pune. With our experienced drivers, enjoy a smooth journey every time."
    },
    {
      "name": "Hinjewadi Cab Service Pune Contact Number",
      "description": "For quick booking and inquiries, reach out to Morya Cab’s customer service for Hinjewadi cab services. We’re just a call away for your travel needs."
    },
    {
      "name": "Taxi Service in Hinjewadi Pune",
      "description": "Morya Cab provides prompt taxi services in Hinjewadi, Pune. Whether you're commuting to work or heading out for leisure, our services are tailored to suit your schedule."
    },
    {
      "name": "Pune Airport to Hinjewadi Taxi Fare",
      "description": "Morya Cab offers affordable taxi services from Pune Airport to Hinjewadi, with competitive fares. Enjoy a comfortable and timely ride without any hidden charges."
    },
    {
      "name": "Cab Service in Hinjewadi Pune",
      "description": "Morya Cab provides reliable and comfortable cab services in Hinjewadi, Pune. Book your ride easily for both local and outstation trips with us."
    },
    {
      "name": "Cab Service in Pune for Outstation",
      "description": "Morya Cab offers outstation cab services from Pune, including Hinjewadi. Whether it's a business trip or leisure travel, we ensure a smooth and comfortable journey."
    },
    {
      "name": "Monthly Taxi Service in Hinjewadi",
      "description": "Morya Cab offers flexible monthly taxi services in Hinjewadi for regular commuters and business professionals. Reliable, affordable, and convenient travel solutions tailored for you."
    },
    {
      "name": "Office Cab Service in Pune",
      "description": "Morya Cab provides dedicated office cab services in Pune, including Hinjewadi. Ensure timely and comfortable travel for your employees with our professional service."
    },
    {
      "name": "Cab Service in Hinjewadi Phase 3",
      "description": "Morya Cab offers fast and reliable cab services in Hinjewadi Phase 3. Book a ride with us for convenient travel to your destination within Pune and beyond."
    },
    {
      "name": "Tempo Traveller on Rent in Hinjewadi",
      "description": "For group trips, Morya Cab offers Tempo Traveller rentals in Hinjewadi. Spacious and comfortable, it’s perfect for family or corporate outings."
    },
    {
      "name": "Mini Bus on Rent in Hinjewadi",
      "description": "Morya Cab provides mini buses on rent in Hinjewadi for group travel. Book a mini bus for a comfortable and convenient journey for your entire group."
    },
    {
      "name": "Hinjewadi to Mumbai Cab",
      "description": "Morya Cab offers reliable and affordable cab services for your journey from Hinjewadi to Mumbai. Enjoy a smooth ride with our professional drivers."
    },
    {
      "name": "Hinjewadi to Mumbai Airport Cab",
      "description": "For a timely and hassle-free ride from Hinjewadi to Mumbai Airport, Morya Cab offers prompt and comfortable taxi services to ensure you catch your flight on time."
    }
  ],


  tableData: [
    ["Hinjewadi Taxi Service", "-Taxi Booking Hinjewadi"],
    ["Taxi in Hinjewadi Pune", "-Cab Service Hinjewadi"],
    ["Hinjewadi Cab Booking", "-Reliable Taxi Hinjewadi"],
    ["Affordable Taxi Hinjewadi", "-24/7 Taxi Service Hinjewadi"],
    ["Luxury Taxi Hinjewadi", "-Hinjewadi Cab Service"],
    ["Taxi Service in Hinjewadi", "-Hinjewadi Cab Service Pune"],
    ["Hinjewadi Cab Service Pune Contact Number", "-Taxi Service in Hinjewadi Pune"],
    ["Pune Airport to Hinjewadi Taxi Fare", "-Cab Service in Hinjewadi Pune"],
    ["Cab Service in Pune for Outstation", "-Monthly Taxi Service in Hinjewadi"],
    ["Office Cab Service in Pune", "-Cab Service in Hinjewadi Phase 3"],
    ["Tempo Traveller on Rent in Hinjewadi", "-Mini Bus on Rent in Hinjewadi"],
    ["Hinjewadi to Mumbai Cab", "-Hinjewadi to Mumbai Airport Cab"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we prioritize punctuality to ensure a smooth experience for your trips in and around Hinjewadi. Whether you’re heading to a corporate meeting, a tech park, or the airport, we guarantee timely pickups and drop-offs."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a variety of well-maintained vehicles for your convenience. Whether you're traveling solo or with a group, we have sedans, SUVs, and premium cars that provide comfortable seating, air-conditioning, and ample legroom to ensure a relaxing ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, courteous, and familiar with the routes around Hinjewadi. They prioritize safety, ensuring a smooth and professional experience from the moment you get in the car."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive and transparent pricing for all our taxi services in Hinjewadi. We believe in providing upfront pricing with no hidden charges, giving you peace of mind that you’re getting the best value for your journey."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles come with modern safety features such as airbags, seat belts, and GPS tracking, ensuring that you have a secure and comfortable journey at all times."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab is available 24/7, so whether you need a taxi early in the morning or late at night, we’re always ready to meet your travel needs. Our customer service team is available round-the-clock to assist you."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a taxi from Hinjewadi is quick and easy. You can book through our website, mobile app, or contact our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you need a taxi for a corporate trip, a leisure outing, or an airport transfer, we offer tailored packages to meet your specific travel needs, ensuring your journey is smooth and enjoyable."
    }
]




















    }

    const faqData = [
        {
          question: "How can I book a taxi in Hinjewadi with Morya Cab?",
          answer: "You can easily book a taxi online through our website or mobile app, or contact our customer service team for any assistance."
        },
        {
          question: "What types of vehicles are available for hire in Hinjewadi?",
          answer: "We offer a variety of vehicles including sedans, SUVs, and premium cars, all well-maintained for your comfort and safety."
        },
        {
          question: "How do I pay for my taxi ride from Hinjewadi?",
          answer: "We offer multiple payment options including cash, credit/debit cards, and online payment via our app."
        },
        {
          question: "Are the drivers experienced for local travel in Hinjewadi?",
          answer: "Yes, all our drivers are experienced and familiar with routes around Hinjewadi, ensuring a smooth and efficient ride."
        },
        {
          question: "Can I book a round trip from Hinjewadi?",
          answer: "Yes, you can easily book a round trip for your travel needs. Just provide us with your return details, and we’ll take care of everything."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges, such as for waiting time or detours, will be communicated to you upfront to ensure complete transparency in pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing in and around Hinjewadi?",
          answer: "Yes, we offer taxi services for sightseeing tours in and around Hinjewadi. Explore local attractions comfortably in one of our well-maintained vehicles."
        },
        {
          question: "What is the luggage allowance for a taxi from Hinjewadi?",
          answer: "Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, kindly inform us during booking, and we’ll make the necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel from Hinjewadi?",
          answer: "Yes, we provide corporate travel services, offering a reliable and comfortable experience for business trips or team outings."
        },
        {
          question: "Why should I choose Morya Cab for taxi service in Hinjewadi?",
          answer: "Morya Cab offers reliable, affordable, and comfortable taxi services with professional drivers, well-maintained vehicles, and transparent pricing, ensuring a smooth and stress-free ride every time."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Rajesh Verma',
          role: 'Corporate Traveler',
          review: "I used Morya Cab for a corporate trip from Hinjewadi to the airport. The driver was on time, polite, and the ride was smooth and comfortable. I’ll definitely use their service again!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Ms. Anjali Mehta',
          role: 'Event Organizer',
          review: "Our team booked a taxi for an event from Hinjewadi, and we had a fantastic experience. The vehicle was clean, comfortable, and the driver was very professional. Highly recommended!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "CarRental",
        "name": "Taxi Service in Hinjewadi Pune",
        "description": "Reliable and affordable taxi service in Hinjewadi, Pune. Offering 24/7 service with a variety of vehicles, including luxury taxis, Tempo Travellers, and Mini Buses for both local and outstation travel.",
        "provider": {
          "@type": "Organization",
          "name": "Hinjewadi Taxi Services",
          "url": "https://www.hinjewaditaxiservices.com",
          "telephone": "+91-9999999999",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Shop No. 10, Hinjewadi IT Park, Pune",
            "addressLocality": "Hinjewadi",
            "addressRegion": "Maharashtra",
            "postalCode": "411057",
            "addressCountry": "IN"
          }
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": 1200,
          "eligibleRegion": {
            "@type": "Place",
            "name": "Hinjewadi"
          },
          "priceValidUntil": "2025-12-31",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "INR",
            "price": "1200",
            "unitCode": "DAY",
            "description": "Taxi service in Hinjewadi Pune for local and outstation trips"
          }
        },
        "keywords": "Hinjewadi Taxi Service, Taxi Booking Hinjewadi, Taxi in Hinjewadi Pune, Cab Service Hinjewadi, Hinjewadi Cab Booking, Reliable Taxi Hinjewadi, Affordable Taxi Hinjewadi, 24/7 Taxi Service Hinjewadi, Luxury Taxi Hinjewadi, Hinjewadi Cab Service, Taxi Service in Hinjewadi, Hinjewadi Cab Service Pune, Hinjewadi Cab Service Pune Contact Number, Taxi Service in Hinjewadi Pune, Pune Airport to Hinjewadi Taxi Fare, Cab Service in Hinjewadi Pune, Cab Service in Pune for Outstation, Monthly Taxi Service in Hinjewadi, Office Cab Service in Pune, Cab Service in Hinjewadi Phase 3, Tempo Traveller on Rent in Hinjewadi, Mini Bus on Rent in Hinjewadi, Hinjewadi to Mumbai Cab, Hinjewadi to Mumbai Airport Cab"
      };
      


    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Taxi Service in Hinjewadi Pune | Reliable & Affordable Taxi Service | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Reliable and affordable taxi service in Hinjewadi, Pune. Offering 24/7 service with a variety of vehicles, including luxury taxis, Tempo Travellers, and Mini Buses for both local and outstation travel."
  />
  <meta
    name="keywords"
    content="Hinjewadi Taxi Service, Taxi Booking Hinjewadi, Taxi in Hinjewadi Pune, Cab Service Hinjewadi, Hinjewadi Cab Booking, Reliable Taxi Hinjewadi, Affordable Taxi Hinjewadi, 24/7 Taxi Service Hinjewadi, Luxury Taxi Hinjewadi, Hinjewadi Cab Service, Taxi Service in Hinjewadi, Hinjewadi Cab Service Pune, Hinjewadi Cab Service Pune Contact Number, Taxi Service in Hinjewadi Pune, Pune Airport to Hinjewadi Taxi Fare, Cab Service in Hinjewadi Pune, Cab Service in Pune for Outstation, Monthly Taxi Service in Hinjewadi, Office Cab Service in Pune, Cab Service in Hinjewadi Phase 3, Tempo Traveller on Rent in Hinjewadi, Mini Bus on Rent in Hinjewadi, Hinjewadi to Mumbai Cab, Hinjewadi to Mumbai Airport Cab"
  />
  <meta property="og:title" content="Taxi Service in Hinjewadi Pune | Reliable & Affordable Taxi Service" />
  <meta
    property="og:description"
    content="Reliable and affordable taxi service in Hinjewadi, Pune. Offering 24/7 service with a variety of vehicles, including luxury taxis, Tempo Travellers, and Mini Buses for both local and outstation travel."
  />
  <meta property="og:url" content="https://www.hinjewaditaxiservices.com" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://www.hinjewaditaxiservices.com/images/hinjewadi-taxi-service.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/86.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Taxiserviceinhinjewadipune;